import UserAccessRights from "../../../component/users/organization-admin/access-rights/UserAccessRights"

  
function AccessRights() {
  return (
    <div className='page-body'>
    <UserAccessRights/>
    </div>
  )
}

export default AccessRights
